import "./symmetric-context/client.js";
import "@lit-labs/ssr-client/lit-element-hydrate-support.js";

// hooks:
import "./hooks/glean-init.js";
import "./hooks/dialog-closedby.js";
import "./l10n/hook.js";
import "./hooks/load-elements.js";
import "./components/baseline-indicator/hook.js";
import "./hooks/sidebar-scroll-to-current.js";
import "./components/navigation/hook.js";
import "./hooks/toc-highlight.js";
import "./hooks/code-examples.js";
import "./hooks/live-samples.js";
import "./hooks/skip-to-search.js";
import "./hooks/user-ping.js";
